module.exports = __webpack_public_path__ + "img/1790398226161_62100.074ddb2f.png";